var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "198px",
    height: "137px",
    viewBox: "0 0 198 137",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Send email") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "97.0872471%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6DC79",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E7B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-2",
    cx: 4.8,
    cy: 26.8,
    r: 4.8
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-31.3%",
    y: "-31.2%",
    width: "162.5%",
    height: "162.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.241315128   0 0 0 0 0.429347826   0 0 0 0 0.0590680508  0 0 0 0.497268357 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-4",
    cx: 171.8,
    cy: 82.6,
    r: 4.8
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-31.3%",
    y: "-31.2%",
    width: "162.5%",
    height: "162.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.241315128   0 0 0 0 0.429347826   0 0 0 0 0.0590680508  0 0 0 0.497268357 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-6",
    cx: 123.8,
    cy: 4.8,
    r: 4.8
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-31.3%",
    y: "-31.2%",
    width: "162.5%",
    height: "162.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-7"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.241315128   0 0 0 0 0.429347826   0 0 0 0 0.0590680508  0 0 0 0.497268357 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Zeplin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy",
    transform: "translate(-823.000000, -83.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Send-email",
    transform: "translate(825.000000, 85.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(33.600000, 16.600000)",
    fill: "#D6E8C5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.88,59.69256 C118.88,26.88648 92.28608,0.29256 59.48,0.29256 C26.67392,0.29256 0.08,26.88648 0.08,59.69256 C0.08,79.98792 10.2644,97.89648 25.7948,108.61008 L93.16736,108.61008 C108.6956,97.89648 118.88,79.98792 118.88,59.69256 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(50.600000, 38.200000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "13.62528 0.3276 13.62528 27.3285205 13.62528 38.0581922 33.59232 54.3276 52.80768 54.3276 72.77472 38.0581922 72.77472 27.3285205 72.77472 0.3276"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#A5C289",
    fillRule: "nonzero",
    points: "85.94208 22.6512 72.77472 22.6512 72.77472 35.23968"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6E8C5",
    fillRule: "nonzero",
    points: "13.62528 35.23968 13.62528 35.23968 13.62528 35.23968 0.45792 22.6512 0.45792 86.00616 33.59232 54.3276"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6E8C5",
    fillRule: "nonzero",
    points: "72.77472 35.23968 72.77472 35.23968 72.77472 35.23968 52.80768 54.3276 85.94208 86.00616 85.94208 22.6512"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#A5C289",
    fillRule: "nonzero",
    points: "13.62528 22.6512 0.45792 22.6512 13.62528 35.23968"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#A5C289",
    fillRule: "nonzero",
    points: "33.59232 54.3276 0.45792 86.00616 85.94208 86.00616 52.80768 54.3276"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.76,
    y1: 21.21264,
    x2: 62.64,
    y2: 21.21264,
    id: "Path",
    stroke: "#B8B8B8",
    strokeWidth: 3.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.76,
    y1: 29.85264,
    x2: 62.64,
    y2: 29.85264,
    id: "Path",
    stroke: "#B8B8B8",
    strokeWidth: 3.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.16,
    y1: 38.49264,
    x2: 58.32,
    y2: 38.49264,
    id: "Path",
    stroke: "#B8B8B8",
    strokeWidth: 3.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.08,
    y1: 38.49264,
    x2: 49.68,
    y2: 38.49264,
    id: "Path",
    stroke: "#B8B8B8",
    strokeWidth: 3.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 68.6,
    y1: 133,
    x2: 119,
    y2: 133,
    id: "Path",
    stroke: "#4C8218",
    strokeWidth: 3.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(49.400000, 39.400000)",
    stroke: "#4C8218",
    strokeLinejoin: "round",
    strokeWidth: 3.24
  }, /*#__PURE__*/React.createElement("line", {
    x1: 86.90208,
    y1: 85.64616,
    x2: 86.90208,
    y2: 22.2912,
    id: "Path",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.41792,
    y1: 22.2912,
    x2: 1.41792,
    y2: 85.64616,
    id: "Path",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "1.41792 85.64616 34.55232 53.9676 1.41792 22.2912 14.58528 22.2912"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    strokeLinecap: "round",
    points: "65.83992 65.50848 53.76768 53.9676 86.90208 22.2912 73.73472 22.2912"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.90208,
    y1: 85.64616,
    x2: 72.0564,
    y2: 71.45064,
    id: "Path",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.55232,
    y1: 53.9676,
    x2: 53.76768,
    y2: 53.9676,
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    strokeLinecap: "round",
    points: "67.65 0.31968 73.73472 0.31968 73.73472 34.87968"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    strokeLinecap: "round",
    points: "14.58528 34.87968 14.58528 0.31968 61.17 0.31968"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-10",
    fill: "url(#linearGradient-1)",
    cx: 193.5,
    cy: 53.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-8",
    fill: "url(#linearGradient-1)",
    cx: 12.5,
    cy: 69.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47,
    y1: 125.8,
    x2: 140.6,
    y2: 125.8,
    id: "Path",
    stroke: "#4C8218",
    strokeWidth: 3.24,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-20"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-27"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-5)",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-29"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-7)",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-26",
    fill: "#FFFFFF",
    cx: 54.8,
    cy: 43.6,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-28",
    fill: "#FFFFFF",
    cx: 144.8,
    cy: 73.6,
    r: 1.8
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailBg);
export default __webpack_public_path__ + "static/media/email_bg.eb24291427cdb5e61cf07bcb76993242.svg";
export { ForwardRef as ReactComponent };